import { Grid2 as Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { DAYS_OF_WEEK, SCHEDULE_TYPES } from "@modules/notifications/validations";

export function ScheduleStep() {
  const translate = useTranslate();
  const scheduleType = useWatch({ name: "schedule_type" });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <Form.Select
          name="schedule_type"
          label={translate("notifications_emails_admin.fields.schedule_type")}
          options={SCHEDULE_TYPES.map((value) => ({
            value,
            label: translate(`notifications_emails_admin.schedule.${value}`),
          }))}
          required
        />
      </Grid>

      {scheduleType === "one_time" ? (
        <Grid size={{ xs: 12, md: 4 }}>
          <Form.Input
            name="date"
            type="datetime-local"
            label={translate("notifications_emails_admin.fields.date")}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>
      ) : (
        <>
          <Grid size={{ xs: 12, md: 5 }}>
            <Form.Select
              name="days_of_week"
              label={translate("notifications_emails_admin.fields.days_of_week")}
              options={DAYS_OF_WEEK.map((value) => ({
                value,
                label: translate(`notifications_emails_admin.days.${value}`),
              }))}
              multiple
              required
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Form.Input
              name="time"
              type="time"
              label={translate("notifications_emails_admin.fields.time")}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
